import smartSolveApi from './instances/smartsolve';

export const prepareDraftData = (entityDataResponse) => {
  const data = entityDataResponse.data;

  if (!data) {
    return;
  }

  if (data.entityDataStoreWithDraftChanges?.entityData) {
    entityDataResponse.data.originalEntityDataStore = data.entityDataStore;
    entityDataResponse.data.entityDataStore = data.entityDataStoreWithDraftChanges;
  }

  delete entityDataResponse.data.entityDataStoreWithDraftChanges;
};

export const getEntityData = async (
  entityType,
  itmId,
  formEntityKey = '',
  workflowId = '',
  stepId = '',
  containerWorkflowKey = '',
  workflowKey = '',
  formStyle = 'ClientEnableForm',
  parentWorkflowId = '',
  entityName = '',
  userKey = '',
  certificationData,
  trainerSignOff
) => {
  try {
    const response = await smartSolveApi.post('/getentitydata', {
      entityType,
      itmId,
      formStyle,
      formEntityKey,
      workflowId,
      stepId,
      containerWorkflowKey,
      workflowKey,
      parentWorkflowId,
      entityName,
      userKey,
      certificationData,
      trainerSignOff,
    });

    prepareDraftData(response);
    return response.data;
  } catch (e) {
    throw new Error(`getEntityData() failed: ${e}`);
  }
};
